/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhostArrow/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhostArrow({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow",
  disabled,
  marginLeft,
  tabIndex = -1,
  onFocus,
  isShowingOptions,
  onBlur,
  size
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="ghost"
 height={16}
 disabled={disabled}
 marginLeft={marginLeft}
 tabIndex={tabIndex}
 paddingLeft={0}
 paddingRight={0}
 onClick={isShowingOptions ? onBlur : onFocus}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={size === "small" ? "14px" : size === "tiny" ? "10px" : "14px"}
 height={size === "small" ? "14px" : size === "tiny" ? "10px" : "14px"}
 fill2={disabled ? dtColorsNeutral300 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}